import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';

SwiperCore.use([Navigation, Scrollbar]);

export default class Testimonials extends HTMLElement {
    /**
     * Class constructor
    */
    constructor() {
        super();
        this.el = this;
        this.carousel = this.querySelector('.swiper');
        this.arrowNext = this.el.querySelector('.swiper-button-next');
        this.arrowPrev = this.el.querySelector('.swiper-button-prev');
        this.scrollbar = this.el.querySelector('.swiper-scrollbar');
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.desktopSlides = parseInt(this.dataset.slidesDesktop, 10) || 3;

        this.init();
    }

    init() {
        if (!this.enableSlider || !this.carousel) {
            return;
        }

        this.createSwiper();
    }

    createSwiper() {
        this.swiper = new Swiper(this.carousel, {
            slidesPerView: 1,
            spaceBetween: 20,
            watchOverflow: true,
            threshold: 10,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true,
                hide: false
            },
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: this.desktopSlides
                }
            }
        });
    }
}

customElements.define('testimonials-carousel', Testimonials);
